import React from 'react';
import {InputAdornment, TextField} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {log} from "three/src/nodes/math/MathNode";
import {Box} from "@mui/system";

const MainOptionsMaterialModuleEntityTextField = ({
                                                      field,
                                                      label,
                                                      values,
                                                      entityList,
                                                      childFirstField,
                                                      disabled,
                                                      setId,
                                                      validationError,
                                                      setValidationState,
                                                      margin = "normal",
                                                      height = 67
                                                  }) => {
    const onChange = (e) => {
        if (validationError) {
            setValidationState((errors) => {
                return {...errors, [field]: ""}
            })
        }
        setId(e.target.value)
    }
    return (
        <Box height={height}>
            <TextField
                autoComplete={"off"}
                error={!!validationError}
                size={"small"}
                disabled={disabled}
                key={field}
                sx={{
                    width: '100%',
                    height: height,
                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    gap: '1.5rem',
                }}
                margin={margin}
                select
                label={label}
                value={values === null ? "" : (values[field] === null ? "" : values[field][childFirstField])}
                name={field}
                onChange={onChange}
            >
                {entityList !== null &&
                    entityList.map((entity) => (
                        <MenuItem key={entity.id} value={entity.id}>
                            {entity.name}
                        </MenuItem>

                    ))}
            </TextField>
        </Box>
    );
};

export default MainOptionsMaterialModuleEntityTextField;
